import 'css-chunksrc/client/common/filterMenu/organizationalUnits/organizationalUnit/styles.scss';export default {
  "organizationalUnit": "_organizationalUnit_f4q8e_1",
  "name": "_name_f4q8e_11"
};